import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  pageHeaderButtonCancel: {
    position: "absolute",
    left: 10,
    textTransform: "none",
    fontSize: 16,
    height: 32,
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  pageHeaderTitle: {
    flex: 1,
    textAlign: "center",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      maxHeight: 30
    }
  },
  pageHeaderSubTitle: {
    fontSize: 14,
    color: "#333333"
  }
}));
